<template>
	<div class="sky-uploadimg" v-bind:class="[getClass, { errorBorder: isTrue }]">
		<ul
			class="el-upload-list el-upload-list--picture-card upload-ul"
			:class="showFileInfo && 'upload-filename'"
		>
			<li
				v-for="(file, index) in editorFileList"
				:key="index"
				tabindex="0"
				class="el-upload-list__item is-success"
			>
				<img
					:src="fileType(file)"
					alt
					class="el-upload-list__item-thumbnail"
					style="object-fit: contain"
				/>
				<span class="el-upload-list__item-actions">
					<span @click="preview(file)" class="el-upload-list__item-preview">
						<i class="el-icon-zoom-in" v-if="isAssetTypeAnImage(file)"></i>
						<i class="el-icon-download" v-else></i>
					</span>
					<span
						@click="editorRemove(file, index)"
						class="el-upload-list__item-delete"
						v-if="!readOnly && !disabled"
					>
						<i class="el-icon-delete"></i>
					</span>
				</span>
				<div class="content" v-if="showFileInfo && file.fileName">
					<div>{{ file.fileName }}</div>
					<div class="download" @click="preview(file)">下载</div>
				</div>
			</li>
		</ul>
		<span v-if="disabled && value.length == 0">暂未上传...</span>
		<el-upload
			v-if="!disabled"
			:action="action"
			:accept="accept || '*'"
			list-type="picture-card"
			:readOnly="readOnly"
			:http-request="action && action != '' ? undefined : uploadSectionFile"
			ref="upload"
			:file-list="fileList"
			:show-file-list="false"
			:on-success="success"
			:on-error="error"
			class="upload"
			:on-preview="preview"
			:on-remove="remove"
		>
			<i class="el-icon-plus"></i>
		</el-upload>

		<b>{{ mistake }}</b>
		<!-- 查看详情图片  -->
		<sky-img-rotate
			:file="currentFile"
			:file-name="filename"
			:visible.sync="dialogVisible"
			title="查看图片"
			:img-url="dialogImgUrl"
			@on-cancel="dialogVisible = false"
			:append="true"
		></sky-img-rotate>
	</div>
</template>

<script>
import skyImgRotate from './sky-img-preview';
import { isAssetTypeAnImage, download } from '@/common/util';
// import { createUpload, ossUpload } from 'sky-ossupload'
import uploadService from 'sky-ossupload';
// import { Get } from 'skytech-request'
import { getDomain } from 'sky-domain';
import OSS from 'ali-oss';
import skyRequest from 'skytech-request';

export default {
	name: 'sky-upload-img',
	props: {
		value: {
			required: true,
		},
		limit: {
			required: false,
		},
		readOnly: {
			required: false,
		},
		bucketType: {
			required: false,
		},
		automistake: {
			required: false,
		},
		disabled: {
			required: false,
		},
		uploadSuccess: {
			required: false,
		},
		removeSuccess: {
			required: false,
		},
		platform: {
			required: false,
			default: 'iglobalwin-pub-oss',
		},
		single: {
			required: false,
			default: false,
		},
		accept: {
			required: false,
		},
		action: {
			required: false,
			default: '',
		},
		envType: {
			required: false,
			default: '1',
		},
		system: {
			required: false,
			default: 'iglobalwin',
		},
		judgeType: {
			required: false,
			default: '',
		},
		judgeSize: {
			required: false,
			default: 0,
		},
		errorCallback: {
			required: false,
		},
		uploadProgress: {
			required: false,
		},
		fileName: {
			required: false,
		},
		showFileInfo: {
			required: false,
			default: false,
		},
	},
	components: {
		skyImgRotate,
	},
	data() {
		return {
			isTrue: false, //错误边框显示
			mistake: '', //错误提示
			dialogVisible: false, //查看大图详情
			dialogImgUrl: '',
			fileList: [],
			ossKey: '',
			isImg: '',
			downurl: '',
			editorFileList: [],
			filename: '',
			currentFile: {},
			uploadStatus: true,
		};
	},
	methods: {
		error() {
			console.log(arguments);
		},
		uploadSectionFile: async function (param) {
			let that = this;

			//自定义文件上传
			let fileObj = param.file;
			let { fileName, uploadProgress } = that;

			try {
				// let oss = await createUpload(
				//   new ossUpload({
				//     Get,
				//     bucket: that.bucket,
				//     envType: that.envType,
				//     system: that.system
				//   })
				// )
				let oss = uploadService({
					request: skyRequest,
					getHost: getDomain,
					platform: that.platform || 'iglobalwin-pub-oss',
					// OSS,
				});

				let convert = await oss.convert({
					file: fileObj,
				});

				let filetype = true;
				let filesize = true;
				if (that.judgeType) {
					filetype = await oss.checkType({
						...convert,
						type: oss.typeMap[that.judgeType],
					});
				}
				if (that.judgeSize) {
					filesize = await oss.checkSize({
						...convert,
						size: that.judgeSize,
					});
				}
				if (!filetype) {
					if (that.errorCallback) return that.errorCallback(convert);
					that.$message.warning('文件类型不符');
					if (!that.errorCallback) throw new Error('文件类型不符');
					return false;
				}
				if (!filesize) {
					if (that.errorCallback) return that.errorCallback(convert);
					if (!that.errorCallback) throw new Error('文件大小不符');
					return false;
				}

				let files = await oss.fileUpload({
					...convert,
					OSS,
					uploadProgress,
					fileName,
				});

				that.ossKey = files.ossName;
				that.fileList = that.$refs.upload.uploadFiles;
				that.fileList.forEach(item => {
					if (item.name == fileObj.name) {
						item.ossName = that.ossKey;
						item.url = files.url;
					}
				});
				that.$message.success('文件上传成功');
				that.isTrue = false; //成功后取消错误提示框
				this.uploadStatus = true;
			} catch (e) {
				that.$refs.upload.uploadFiles = _.drop(this.$refs.upload.uploadFiles, 1);
				// that.$message.warning('文件上传失败');
				this.uploadStatus = false;
				// that.$message.warning('文件上传失败');
				console.error(e);
			}
		},
		preview(file) {
			//查看图片
			if (!isAssetTypeAnImage(file.ossName.split('.')[1])) {
				console.log('下载', file.url);
				const a = document.createElement('a');
				a.style.display = 'none';
				fetch(file.url)
					.then(res => res.blob())
					.then(blob => {
						// 将链接地址字符内容转变成blob地址
						a.href = URL.createObjectURL(blob);
						a.download = file.fileName; // 下载文件的名字
						document.body.appendChild(a);
						a.click();
					});
				// download({
				// 	fileName: file.fileName,
				// 	url: file.url,
				// });
			} else {
				this.dialogImgUrl = file.url;
				this.filename = file.fileName;
				this.currentFile = file;
				this.dialogVisible = true;
			}
		},
		remove(file) {
			//删除图片
			let index = _.findIndex(this.fileList, item => item === file);
			this.fileList.splice(index, 1);

			this.$emit('input', this.getFileList);
			this.removeSuccess && this.removeSuccess(file, index);
		},
		editorRemove(file, index) {
			//编辑删除图片
			this.editorFileList.splice(index, 1);
			this.$emit('input', this.getFileList);
			this.removeSuccess && this.removeSuccess(...arguments);
		},
		isAssetTypeAnImage(file) {
			if (file.ossName) {
				return isAssetTypeAnImage(file.ossName.split('.')[1]);
			}
		},
		fileType(file) {
			if (file.ossName) {
				const fileTypeList = {
					// 图片 文本 压缩包 媒体 编程 字体
					word: {
						doc: true,
						docx: true,
						wps: true,
					},
					pdf: {
						pdf: true,
					},
					ppt: {
						ppt: true,
						pptx: true,
					},

					excel: {
						xls: true,
						xlsx: true,
					},

					html: {
						html: true,
						htm: true,
						stm: true,
						xhtml: true,
					},

					css: {
						css: true,
						scss: true,
						less: true,
					},
					js: {
						js: true,
						jsp: true,
					},

					json: true,
					vue: true,

					txt: {
						doc: true,
						docx: true,
						wps: true,
						ppt: true,
						pptx: true,
						xls: true,
						xlsx: true,
						txt: true,
						pdf: true,
						md: true,
						rtf: true,
					},
					code: {
						html: true,
						htm: true,
						stm: true,
						xhtml: true,
						css: true,
						js: true,
						jsp: true,
						json: true,
						vue: true,
						scss: true,
						less: true,
						java: true,
						h: true,
						c: true,
						exe: true,
						dll: true,
						lib: true,
						dsp: true,
						dsw: true,
						cpp: true,
						cs: true,
						asp: true,
						aspx: true,
						php: true,
						net: true,
					},
					rar: {
						rar: true,
						zip: true,
						arj: true,
						gz: true,
						'7z': true,
					},
					img: {
						bmp: true,
						gif: true,
						jpg: true,
						jpeg: true,
						jpe: true,
						pic: true,
						png: true,
						tif: true,
						tiff: true,
						svg: true,
					},
					audio: {
						wav: true,
						aif: true,
						au: true,
						mp3: true,
						ram: true,
						wma: true,
						mmf: true,
						amr: true,
						aac: true,
						flac: true,
					},
					video: {
						avi: true,
						mpg: true,
						mov: true,
						swf: true,
						mp4: true,
						wmv: true,
						mpeg: true,
						mpeg1: true,
						mpeg2: true,
						dv: true,
						mkv: true,
					},
					font: {
						eot: true,
						woff: true,
						woff2: true,
					},
				};

				const type = file.ossName.split('.')[1]; // 截取的图片类型
				if (isAssetTypeAnImage(type)) {
					return file.url;
				} else {
					let imgUrl;
					let status = true;
					Object.keys(fileTypeList).forEach(item => {
						console.log(item);
						if (typeof fileTypeList[item] == 'boolean' && item == type && status) {
							status = false;
							imgUrl = require(`../../../assets/${item}.png`);
						} else if (
							typeof fileTypeList[item] == 'object' &&
							fileTypeList[item][type] &&
							status
						) {
							status = false;
							imgUrl = require(`../../../assets/${item}.png`);
						} else {
							status = false;
							imgUrl = require(`../../../assets/file.png`);
						}
					});

					return imgUrl.default || imgUrl;
				}
			}
		},
		success(response, file) {
			if (!this.uploadStatus) return false;
			this.editorFileList.push({
				fileName: file.name,
				ossName: file.ossName,
				url: file.url,
			});
			this.uploadSuccess &&
				this.uploadSuccess(this.editorFileList[this.editorFileList.length - 1], this.getFileList);
			// this.value.concat(tepmFileList)
			this.$emit('input', this.getFileList);
		},
	},
	computed: {
		getClass() {
			let count = this.getFileList ? this.getFileList.length : 0;
			if (this.limit && this.limit == count) {
				//限制添加图片
				return ['hide-add-btn', 'uploadImg'];
			} else {
				return ['uploadImg'];
			}
		},
		getFileList() {
			// let list = _.map(this.fileList, item => {
			//   return {
			//     fileName: item.name,
			//     ossName: item.ossName,
			//     url: item.url
			//   };
			// });
			return this.editorFileList;
		},
	},
	watch: {
		value(newVal) {
			if (JSON.stringify(newVal) !== JSON.stringify(this.getFileList)) {
				this.editorFileList = this.value.concat();
				this.fileList = [];
			}
		},
	},
	mounted() {
		this.editorFileList = this.value.concat();
	},
};
</script>

<style>
.errorBorder b {
	display: block;
	color: red;
}

.errorBorder .upload {
	padding: 10px;
	border: 1px solid red;
	border-radius: 4px;
}

.el-upload--picture-card {
	background: #f2f2f2;
	border: none;
	width: 80px;
	height: 80px;
	line-height: 80px;
}

.el-upload-list--picture-card .el-upload-list__item {
	width: 80px;
	height: 80px;
}

.hide-add-btn .el-upload--picture-card {
	display: none;
}
</style>
<style scoped>
.upload {
	height: 80px;
}

.sky-uploadimg {
	display: flex;
	flex-wrap: wrap;
}
</style>
